import React from 'react'

const List: React.FC = ({ children }) => {
  return <ul className="list-disc">{children}</ul>
}

export default List
